import { ApiDB } from './apiDB';

export type { SpinRecord, WheelDB } from './types';
export { LocalStorageDB } from './localStorageDB';
export { ApiDB } from './apiDB';

export const db = new ApiDB('https://api.hoaxcoffee.com', process.env.REACT_APP_API_KEY!);
